import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getNonSaleNotesCollectionsAction } from '../actions/actions';

const {
  useLoader: usePaymentHubCollectionsWithoutSalenoteLoader,
  LoaderProvider,
} = createLoaderImp({
  action: getNonSaleNotesCollectionsAction,
});

function PaymentHubCollectionsWithoutSalenoteData({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return <LoaderProvider {...props}>{children}</LoaderProvider>;
}

export {
  PaymentHubCollectionsWithoutSalenoteData,
  usePaymentHubCollectionsWithoutSalenoteLoader,
};
